<div class="modal-header">
    <span><i class="fa fa-cog mr-2"></i>{{title}}</span>
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="close()" >
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>  
<div class="modal-body">
    <ng-content #component></ng-content>
</div>
<div class="modal-footer">
    <button type="button"  class="btn btn-outline-success" [disabled]="!showSave" (click)="save()"><i class="fa fa-save mr-2"></i>Salva</button>
    <button type="button" class="btn btn-outline-secondary" (click)="close()"><i class="fas fa-times mr-1"></i>Chiudi</button>
</div>